import { useEffect, useState, createContext, useContext, ReactNode } from 'react'

import { setServerErrorFn } from 'services/api'
import { setServerErrorFn as setDwaApiServerErrorFn } from 'services/dwaApi'

const ServerErrorContext = createContext<any>(null) // eslint-disable-line @typescript-eslint/no-explicit-any

export const ServerErrorContextProvider = ({ children }: { children: ReactNode }) => {
  const [serverError, setServerError] = useState<string>('')

  useEffect(() => {
    setServerErrorFn((errorMessage) => setServerError(errorMessage))
    setDwaApiServerErrorFn((errorMessage) => setServerError(errorMessage))
  }, [])

  return (
    <ServerErrorContext.Provider value={{ serverError, setServerError }}>
      {children}
    </ServerErrorContext.Provider>
  )
}

export const useServerErrorContext = () => useContext(ServerErrorContext)
